import { clamp } from '@djs';
import { MAX_ATTACH_HEIGHT_PX } from '@dui/MessageBubbleAttachImage/const';
import { MessageItemSize } from './types';

export const getMessageSizes = (
  imageSizes: { width: number; height: number }[] = [],
  voiceMessageDuration?: number,
): MessageItemSize => {
  if (voiceMessageDuration) {
    return {
      widthRatio: clamp(voiceMessageDuration / 16, 0, 1),
      minWidth: 165,
      maxWidth: void 0,
    };
  }

  if (!imageSizes.length) {
    return {
      widthRatio: void 0,
      minWidth: void 0,
      maxWidth: void 0,
    };
  }

  const maxOriginWidth = Math.max(...imageSizes.map((s) => s.width));
  const maxSizes = imageSizes.find((s) => s.width === maxOriginWidth);
  const maxWidth = maxSizes ? (maxSizes.width / maxSizes.height) * MAX_ATTACH_HEIGHT_PX : void 0;

  return {
    widthRatio: 1,
    minWidth: 200,
    maxWidth,
  };
};
